import React, { useEffect, useState } from "react";
import { getFinalCTA } from "../api/companyService";
import { sleep } from "../utils/sleep";

const FinalCTA = () => {
  const [finalCTA, setFinalCTA] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
  
      useEffect(() => {
      const fetchFinalCTA = async () => {
        try {
          // simulate network delay (3 sec)
          //await sleep(3000);
  
          const data = await getFinalCTA(); // asynchronous call
          setFinalCTA(data);
        } catch (err) {
          setError("Failed to load Final CTA.");
        } finally {
          setLoading(false);
        }
      };
  
      fetchFinalCTA();
      }, []);
    
    // Loading Overlay
    if (loading) {
      return (
        <div className="loading-overlay d-flex align-items-center justify-content-center py-5">
          <div className="spinner-border text-primary" role="status"></div>
          <span className="ms-3 fw-semibold">Loading final CTA...</span>
        </div>
      );
    }
    
     // Error Message
    if (error) {
      return (
        <div className="error-container d-flex flex-column align-items-center justify-content-center py-5">
          <p className="text-danger fs-7">{error}</p>
          <button
            className="btn btn-outline-primary mt-3"
            onClick={() => window.location.reload()}
          >
            Retry
          </button>
        </div>
      );
  }
  
  return (
      <section className="py-5 text-center text-white" style={{ backgroundColor: finalCTA.bgColor}}>
        <div className="container">
          <h4 className="mb-3">{finalCTA.title}</h4>
          <a href={finalCTA.buttonLink} className="btn mt-3 bg-primary-color text-secondary-color">{finalCTA.buttonText}</a>
        </div>
      </section>
  );
};

export default FinalCTA;
